import { helloWorld } from "./hello-world";
import "./buttons";
import "./gf-live-validation";
import "./file-upload";
import "./embla";
import "./lightbox";
import "./privacy-modal";
import { initIoReveal } from "./io-reveal";
import { initHeroParallax } from "./hero-parallax";

helloWorld("from boilerplate");
initIoReveal();
initHeroParallax();

// Lazy-load the globe bundle once the global-reach section approaches the
// viewport. Code-split so the heavy three.js+globe.gl payload stays out of
// the initial network waterfall; an IntersectionObserver (200px lookahead)
// defers the dynamic import() further until the section is actually about to
// scroll into view.
//
// Lifecycle mirrors scripts/solution-journey.ts: htmx:load / historyRestore
// (re)arm the observer, htmx:before-swap tears it down and clears the WeakSet
// guard — a boosted nav away+back must re-arm on fresh DOM, not silently
// no-op because a stale node was "seen" before.
let globeMod: typeof import("./globe-demo") | null = null;
const globeSectionObservers = new WeakMap<Element, IntersectionObserver>();
const globeSectionsWatched = new WeakSet<Element>();

async function loadGlobe(): Promise<void> {
  if (!globeMod) globeMod = await import("./globe-demo");
  globeMod.initGlobe();
}

function watchGlobeSection(section: Element): void {
  if (globeSectionsWatched.has(section)) return;
  globeSectionsWatched.add(section);

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      globeSectionObservers.delete(section);
      void loadGlobe();
    },
    { rootMargin: "200px 0px" },
  );
  observer.observe(section);
  globeSectionObservers.set(section, observer);
}

function watchGlobeSectionsAll(): void {
  document
    .querySelectorAll(".section--global_reach")
    .forEach(watchGlobeSection);
}

function unwatchGlobeSectionsAll(): void {
  document.querySelectorAll(".section--global_reach").forEach((section) => {
    globeSectionObservers.get(section)?.disconnect();
    globeSectionObservers.delete(section);
    globeSectionsWatched.delete(section);
  });
}

document.addEventListener("DOMContentLoaded", watchGlobeSectionsAll);
document.addEventListener("htmx:load", watchGlobeSectionsAll);
document.addEventListener("htmx:historyRestore", watchGlobeSectionsAll);
document.addEventListener("htmx:before-swap", unwatchGlobeSectionsAll);

let mapMod: typeof import("./map") | null = null;
async function maybeLoadMap(): Promise<void> {
  if (!document.getElementById("map")) return;
  if (!mapMod) mapMod = await import("./map");
  await mapMod.tryInitMap();
}
document.addEventListener("DOMContentLoaded", maybeLoadMap);
document.addEventListener("htmx:load", maybeLoadMap);
